export default __webpack_public_path__ + "static/media/233.d58546bf.jpg";